import { ReactElement, useState } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

const savedButWithoutOverviewFlagDialogOptions = {
  render: (message: string, onOk: () => void): any => {
    return <KendoDialog message={message} onOk={onOk} />;
  },
};

interface KendoDialogProps {
  readonly message: string;
  readonly onOk: () => void;
}

function KendoDialog({ message, onOk }: KendoDialogProps): ReactElement {
  const [visible, setVisible] = useState(true);
  const toggleDialog = () => {
    setVisible(!visible);
  };

  return visible ? (
    <Dialog title="Project saved" onClose={toggleDialog}>
      <p
        style={{
          margin: "25px",
          textAlign: "center",
        }}
      >
        But without Flag &#34;Show in Overview&rdquo;.
        <br />
        {message} for saving with Flag &#34;Show in Overview&rdquo;.
      </p>
      <DialogActionsBar>
        <button
          type="button"
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
          onClick={() => {
            toggleDialog();
            onOk();
          }}
        >
          Ok
        </button>
      </DialogActionsBar>
    </Dialog>
  ) : (
    <div />
  );
}

export default savedButWithoutOverviewFlagDialogOptions;
